import React, { useState } from 'react';
import { UserPlus, Check, Eye, EyeOff } from 'lucide-react';
import { useSignupForm } from '../../../hooks/useSignupForm';
import { useLocation } from 'react-router-dom';
import { ErrorMessage } from '../login/ErrorMessage';
import { SignupLinks } from './SignupLinks';

export function SignupForm() {
  const location = useLocation();
  
  const {
    email,
    password,
    confirmPassword,
    referralCode,
    error,
    isLoading,
    handleEmailChange,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleReferralCodeChange,
    setReferralCode,
    handleSubmit
  } = useSignupForm();
  
  // URLからリファラルコードを取得
  const [showReferralCode, setShowReferralCode] = useState(false);
  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get('ref');
    
    if (ref) {
      try {
        // 暗号化されたコードをそのまま使用
        setReferralCode(ref);
      } catch (error) {
        console.error('Failed to decode referral code:', error);
      }
    }
  }, [location.search, setReferralCode]);

  return (
    <div className="mt-8 space-y-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-4">
          <div className="space-y-1">
            <label htmlFor="email-address" className="sr-only">
              メールアドレス
            </label>
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={handleEmailChange}
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="メールアドレス"
            />
          </div>
          <div className="space-y-1">
            <label htmlFor="password" className="sr-only">
              パスワード
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              value={password}
              onChange={handlePasswordChange}
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="パスワード（8文字以上）"
            />
          
            <label htmlFor="confirm-password" className="sr-only">
              パスワード（確認用）
            </label>
            <input
              id="confirm-password"
              name="confirmPassword"
              type="password"
              autoComplete="new-password"
              required
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="パスワード（確認用）"
            />
          </div>
          <div className="mt-4 relative">
            {referralCode ? (
              <div className="flex items-center">
                <button
                  type="button"
                  className="appearance-none relative flex items-center justify-between w-full px-3 py-2 border border-green-300 bg-green-50 text-green-700 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
                  onClick={() => setShowReferralCode(!showReferralCode)}
                >
                  <div className="flex items-center">
                    <Check className="h-4 w-4 text-green-500 mr-2" />
                    <span>紹介コード入力済み</span>
                  </div>
                  {showReferralCode ? (
                    <EyeOff className="h-4 w-4 text-green-500" />
                  ) : (
                    <Eye className="h-4 w-4 text-green-500" />
                  )}
                </button>
              </div>
            ) : (
              <>
                <label htmlFor="referral-code" className="sr-only">
                  紹介者コード
                </label>
                <input
                  id="referral-code"
                  name="referralCode"
                  type="text"
                  value={referralCode}
                  disabled={true}
                  onChange={handleReferralCodeChange}
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="紹介者コード (任意)"
                />
              </>
            )}
            {showReferralCode && (
              <div className="mt-2 p-2 bg-green-50 border border-green-100 rounded-md">
                <p className="text-xs text-green-700 break-all">{referralCode}</p>
              </div>
            )}
          </div>
        </div>

        <ErrorMessage error={error} />

        <div>
          <button
            type="submit"
            disabled={isLoading}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400 disabled:cursor-not-allowed"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <UserPlus className={`h-5 w-5 text-blue-500 group-hover:text-blue-400 ${
                isLoading ? 'animate-pulse' : ''
              }`} />
            </span>
            {isLoading ? '登録中...' : '新規会員登録'}
          </button>
        </div>
      </form>

      <SignupLinks />
    </div>
  );
}